export default __webpack_public_path__ + "Content/Images/content/power-of-interest.jpg";